import * as React from "react";
import * as ReactDOM from 'react-dom';
import { observable, action } from "mobx";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import ProfileStore from "../../../stores/profileStore";
import Snackbar from 'material-ui/Snackbar';
import Fade from 'material-ui/transitions/Fade';

@observer
export default class ProficiencyIndicator extends React.Component<{indicator: number, usage: number}, {}> {

  @observable color: string;
  private ctx: CanvasRenderingContext2D;
  private canvas: HTMLCanvasElement;

  refs: {
    canvas: HTMLCanvasElement;
  };

  constructor(props: any) {
    super(props);
    this.color = "#DCE1E5"
  }

  componentDidMount() {
    this.canvas = (ReactDOM.findDOMNode(this.refs.canvas) as HTMLCanvasElement);
    this.ctx = this.canvas.getContext('2d')!;
    this.updateCanvas();
  }
  componentDidUpdate(): void {
    this.updateCanvas();
  }
  updateCanvas(): void {
    this.drawBase(this.ctx);
    this.drawSeekerUsage(this.ctx, this.props.usage);
    this.drawBar(this.ctx, this.props.indicator);
  }
  drawBase(ctx: any) {
    //background light grey triangle
    const w: number = ctx.canvas.width;
    const h: number = ctx.canvas.height;
    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = "#5c7d7b";
    ctx.moveTo(0, h);
    ctx.lineTo(w, h);
    ctx.lineTo(w, 0);
    ctx.closePath();
    ctx.stroke();
  }

  drawSeekerUsage(ctx: any, usage: number) {
    //shows the level the employee is at given a skill 
    const w: number = ctx.canvas.width;
    const h: number = ctx.canvas.height;
    const max: number = 5;
    ctx.beginPath();
    ctx.fillStyle = "#8AACAA";
    ctx.moveTo(0, h);
    ctx.lineTo(usage / max * w, h);
    ctx.lineTo(usage / max * w, h - usage / max * h);
    ctx.fill();
  }

  drawBar(ctx: any, target: number) {
    //line indicated by how employer
    const w: number = ctx.canvas.width;
    const h: number = ctx.canvas.height;
    const max: number = 5;
    ctx.fillStyle = "#327030";
    ctx.beginPath();
    var delta = 1.5;
    ctx.moveTo((target / max) * w - delta, h);
    ctx.lineTo((target / max) * w + delta, h);
    ctx.lineTo((target / max) * w + delta, h * (1 - target / max));
    ctx.lineTo((target / max) * w - delta, h * (1 - target / max) + 1);
    ctx.closePath();
    ctx.fill();
  }

  render(): JSX.Element {
    //const lbl: string = this.props.usage ? this.props.usage.toFixed(2) : "?";
    //return <div>{lbl}</div>
    return <canvas ref="canvas" id="canvas" width={54} height={20}/>
  }
}






// WEBPACK FOOTER //
// ./src/components/widgets/Indicator/index.tsx